import { useRecoilValue } from 'recoil'
import { langDirection } from '@Modules/hubs/atoms'

export const useWrapperProps = (props: any) => {
  const dir = useRecoilValue<'RTL' | 'LTR'>(langDirection)
  const propsStyle = props.style ?? {}
  const style = dir === 'RTL' ? { ...propsStyle, transform: 'scale(-1, 1)' } : propsStyle
  const { Component, componentRef, ...rest } = props
  return { dir, style, Component, componentRef, rest }
}
